//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//局部注册组件
// import Header from './repair_details_head'
import { Uploader,Popup,RadioGroup,Radio,Checkbox,CheckboxGroup,Dialog,Loading,Rate,Notify,ImagePreview  } from 'vant';
 import global from '../../../static/js/global'
import { setTimeout } from 'timers';
export default {
  components:{
       [Uploader.name]: Uploader,
       [Radio.name]: Radio,
       [RadioGroup.name]: RadioGroup,
       [Checkbox.name]: Checkbox,
       [CheckboxGroup.name]: CheckboxGroup,
       [Popup.name]: Popup, 
       [Dialog.name]: Dialog,   
       [Loading.name]: Loading,  
       [Rate.name]: Rate,  
       [Notify.name]: Notify,   
       [ImagePreview.name]: ImagePreview,
  },
  data() {
    return {
        pingj:false, // 未评价是false 评价了是true
        evaluate: false,
        jind:false, // 未接单
        jind2:false, // 接单
        worker:false, //为false维修工未接单 true维修工接单
         valueone: '5',
        valuetwo: '4',
        value: '',
        Dictionaries:[], // 评分标签
        Dictionaries_list:[],// 用户选择的评价标签
        percentage: 60,
         userList:{}, // 派单信息数据集
    //    新增进度条 未派单的情况下
      list:{
            percentage: 0,
            orderList:[]
          },
    //   orderProgress:{
    //             percentage: 0,  //订单当前总进度0-100  0==开始  100==完成
    //             //进度阶段List
    //             orderList:[]
    //     },
      loging:true, // 是否显示加载
      //数据集
      orderDetails:{
      },
      images:[],       // 如果有图片 这个就是存图片id的数组
      imgageBase:[],   // 存放图片、
      repairState:'', // 0:待受理；1:处理中；2：已完成待回访3：已回访待评价 4：已评价
      handleMan:'', // 维修人 下一步发请求需要传的参数
      handleId:'',
      repairType:[],
      scroll: false
    }
  },
  watch: {
    scroll: function() {
      this.$nextTick(() => {
         var scrollTop = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset
        //  alert('赋值前------'+scrollTop)
        // let boxHeight = document.documentElement.scrollHeight || document.body.scrollHeight 
        //  if(scrollTop != document.body.scrollHeight){
        //      scrollTop = document.body.scrollHeight;
        //      document.documentElement.scrollTop = scrollTop; document.getElementById('home').scrollHeight
        //  }
         scrollTop = document.getElementById('warper').scrollHeight;
          document.documentElement.scrollTop = scrollTop;
        //  alert('赋值后------'+scrollTop)
        console.log(document.body.scrollHeight)
        
      });
    }
  },
  mounted() {
   this.getAllList()
   this.getAllListUser()
   this.getDictionaries()
  },
  methods:{
    clkImg(){
        ImagePreview(this.imgageBase)
    },
      // 删除指定元素公共方法
      removeByValue(arr, val) {
       for(var i = 0; i < arr.length; i++) {
        if(arr[i] == val) {
         arr.splice(i, 1);
         break;
        }
       }
      },
       // 获取字典
      getDictionaries(){
        this.$http.get( global.host +"repairMgr/findDictList?domain=REPAIR_SCOPE_LABEL", ).then(
                function(res) {
                  if(res.body.statusCode == 200){
                    this.Dictionaries = res.body.result;
                   console.log(this.Dictionaries)
                  }
                   
                },
                function(err) {
                    console.log(err);
                });
      },
       // 点击保存字典值 切换颜色
      getSazd(item,e){
          console.log(item)
          console.log(e.target.classList)
          if(e.target.classList.contains('dictionaryColor')){
              e.target.classList.remove('dictionaryColor');
              this.removeByValue(this.Dictionaries_list,item)
          }else{
             this.Dictionaries_list.push(item);
              e.target.classList.add('dictionaryColor');
          }
      },
      // 控制大盒子的margin
      marWoeker(){
          if(this.worker == true){  //  如果维修工人接单了 大盒子的margin为100
             this.$refs.ulBox.style.margin = '0 0 100px 0'
          }
        
      },
      //点击展示评分项
      giveMark(){
          if(this.repairState== 2 || this.repairState == 3){
           this.evaluate = true
        //   alert('评价')
        }else{
           Notify({
            message: '该订单无法评价',
            duration: 2000,
            background: '#1989fa'
            });
        }
      },
      // 点评价取消
      del(){
        this.evaluate = false;
      },
      // 提交评价
      payment(){
          if(this.pingj == false){
              this.Dictionaries_list = this.Dictionaries_list.join(','); 
         console.log( this.Dictionaries_list)
         let submitScore = {};
          submitScore.repairId = this.$router.history.current.query.repairId;
          submitScore.handleScode = String(this.valueone);
          submitScore.serviceScode = String(this.valuetwo);
          submitScore.scodeDesc = this.Dictionaries_list;
          this.$http.post(global.host + 'repair/submitScore',submitScore).then(function(res){
             console.log(res)
             if(res.body.statusCode == 200){
               this.getAllListUser()
                     this.getUser()
                     this.evaluate = false;
                    this.pingj = true
                  }
           },function(err){
               console.log(err)
           })
          }else{
              Notify({
            message: '请勿重复评价',
            duration: 2000,
            background: '#1989fa'
            });
          }
         
        console.log(submitScore)
      },
      // 获取基本信息
      getUser(){
          let userall = {};
          userall.handleMan = this.handleId;
           console.log('基本信息基本信息'+this.handleId)
          this.$http.post(global.host + '/repair/findOrderQuantity',userall).then(function(res){
             console.log('基本信息基本信息基本信息基本信息基本信息基本信息基本信息基本信息')
             console.log(res)
             this.userList = res.body.result
             this.value = res.body.result.avgNum
             
           },function(err){
               console.log(err)
           })
      },
     // 获取展示数据集
    getAllList(){
            this.$http.get( global.host +"repair/findRepairDetail?repairId="+this.$router.history.current.query.repairId, ).then(
                    function(res) {
                        console.log('详情的数据详情的数据详情的数据详情的数据详情的数据详情的数据详情的数据详情的数据详情的数据详情的数据详情的数据详情的数据')
                        console.log(res);
                        if(res.body.statusCode == 200){
                            this.orderDetails = res.body.result;
                            this.repairType = this.orderDetails.repairType.split(',');
                            console.log('8888888888888888888888888888888888888888888')
                            console.log(this.repairType)
                            this.repairState = res.body.result.repairState;
                            this.handleMan = res.body.result.handleMan; //如果pc未派单 这个值为null 用户进来不显示头部 不为null才显示
                            if(this.handleMan == null){
                                this.worker = false
                            }else{
                                this.worker = true
                            }
                           
                            console.log('之后的this.worker-----------'+this.worker)
                            console.log(this.worker)
                            this.handleId =res.body.result.handleId; 
                            console.log('刚赋值的this.handleId ------------------------'+this.handleId)
                            console.log(this.handleId)
                            this.getUser()
                             this.marWoeker()
                            console.log(this.handleMan)
                            if(this.orderDetails.images.length != 0){
                                this.images = this.orderDetails.images;
                                // 发送请求获取图片
                                for(var i = 0; i < this.images.length; i++){
                                    this.getImages(this.images[i])
                                }
                            }else{
                                this.loging = false;
                            }
                        }
                    
                },
                function(err) {
                    console.log(err);
                });

    },
    // 获取图片的ajax
    getImages(imgId){
        this.$http.get( global.host +"repairMgr/findPictureByPicId?pictureId="+imgId, ).then(
                function(res) {
                    this.imgageBase.push(res.url)
                    this.loging = false;
                },
                function(err) {
                    console.log(err);
                });
    },
      // 如果未接单 逻辑
      // 如果未接单 箭头向上事件 点击填充数据
    swipeup(){
        console.log("箭头向上事件")
        this.jind = true
        console.log(this.worker)
        console.log(this.jind)
        if(this.jind == true){
            this.$refs.warperRef.style.margin='0 0 150px 0'
            this.scroll = true;
        }else{
             this.$refs.warperRef.style.margin='0 0 0 0'
        }
    },
     // 如果接单
     swipeupWorker(){
        //  alert('接单上拉事件')
         this.jind2 = true
         this.$refs.ulBox.style.margin = '0 0 450px 0'
     },
     downWorken(){
          this.jind2 = false
          this.$refs.ulBox.style.margin = '0 0 100px 0'
     },
      
      // 获取进度条数据
          // 时间戳转换兼容判断机型
    formatDate(date, type) {
        if (date != undefined) {
            //兼容ios
            if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent) || navigator.userAgent.indexOf("Safari") > -1) {
                date = String(date).replace(/\-/g, "/")
            }
            var time = '';
            if (date.indexOf('-') != -1 || date.indexOf('/') != -1) {
                time = new Date(date)
            } else {
                time = new Date(JSON.parse(date))
            }
            var year = time.getFullYear();
            var month = time.getMonth() + 1;
            var date = time.getDate();
            var hours = time.getHours();
            var minutes = time.getMinutes();
            var seconds = time.getSeconds();
            var isTime = '';
 
            function add0(m) { return m < 10 ? '0' + m : m }
            switch (type) {
                case 'Y-M-D hh:mm:ss':
                    isTime = year + '-' + add0(month) + '-' + add0(date) + ' ' + add0(hours) + ':' + add0(minutes) + ':' + add0(seconds);
                    break;
                case 'M-D hh:mm:ss':
                    isTime = add0(month) + '-' + add0(date) + ' ' + add0(hours) + ':' + add0(minutes) + ':' + add0(seconds);
                    break;
                case 'M-D hh:mm':
                    isTime = add0(month) + '-' + add0(date) + ' ' + add0(hours) + ':' + add0(minutes);
                    break;
                case 'hh:mm:ss':
                    isTime = add0(hours) + ':' + add0(minutes) + ':' + add0(seconds);
                    break;
                case 'hh:mm':
                    isTime = add0(hours) + ':' + add0(minutes);
                    break;
            }
            return isTime;
        }
    },
    // 兼容时间格式
    getTs(time){
          var arr = time.split(/[- :]/),
          _date = new Date(arr[0], arr[1]-1, arr[2], arr[3], arr[4], arr[5]),
          timeStr = Date.parse(_date)
          return timeStr
      },
      // 获取进度展示展示数据集
      getAllListUser(){
        this.list.orderList = []
        this.$http.get( global.host +"repair/findHandleRecord?repairId="+this.$router.history.current.query.repairId, ).then(
                function(response) {
                    // alert('进度数据')
                    // alert(JSON.stringify(response));
                    // demo
                    this.loging = false
          for(var i = 0 ; i < response.body.result.length; i++){
            var data = {
              id: i,   //当前阶段id
              title: response.body.result[i].handleStatus,  //当前阶段订单标题
              context: response.body.result[i].handleDesc,  //当前阶段订单内容
              dataTime: response.body.result[i].handleDate,   //当前阶段订单结束时间
            }
            this.list.orderList.push(data);
          }
          for(var i = 0 ; i < this.list.orderList.length; i++){
              //每次进度之后时间戳
              var timestamp2 = this.formatDate(this.list.orderList[i].dataTime,'Y-M-D hh:mm:ss');
              //开始时间戳
              var timestamp1 = this.formatDate(this.list.orderList[0].dataTime,'Y-M-D hh:mm:ss');
              //之后时间戳减开始
              var num = this.getTs(timestamp1) - this.getTs(timestamp2);
              //获取到总共时间
              var second = (num/1000);
              //判断当前度是否大于等于0
              if(parseInt(second/3600) <= 0){
                //最小0
                this.list.orderList[i].top = 0;
              }else{
                //长度拼接
                this.list.orderList[i].top = parseInt(second/3600) + "0";
              }
              
          }
          //计算当前进度的总长度
          //获取最后时间戳
          var timestamp4 = this.formatDate(this.list.orderList[this.list.orderList.length - 1].dataTime,'Y-M-D hh:mm:ss');
          //获取开始时间戳
          var timestamp3 = this.formatDate(this.list.orderList[0].dataTime,'Y-M-D hh:mm:ss');
          //计算时间戳之差
          let num1 = this.getTs(timestamp3) - this.getTs(timestamp4);
          //获取到总时长
          var second1 = (num1/1000);
          //判断总长度是否大于等于0
          if(parseInt(second1/3600) <= 0){
            //最小0
            this.list.percentage = 0;
          }else{
            //拼接总进度长度
            this.list.percentage = parseInt(second1/3600) + "0";
          }
          //判断进度总长是否超过600
          if(this.list.percentage > 600){
            //总进度超过600减半
            for (var j = 0 ; j < this.list.orderList.length; j++) {
              //每个进度减半
              this.list.orderList[j].top = this.list.orderList[j].top / 2;
            }
            //总长度减半
            this.list.percentage = this.list.percentage / 2;
          }
          //记录总加了多少长度
          var nuber = 0;
          //判断每个进度之间不能少于70px,少于70px,赋值给最低70
          for (var j = 0 ; j < this.list.orderList.length; j++) {
            //开始第一个阶段不用高度
            if(j == 0){
            }else{
              //判断高度是否大于70
              if(this.list.orderList[j].top < 70 ){
                // //小于70记录与70之间的差
                // nuber = 70 - this.list.orderList[j].top + nuber;
                //给本阶段赋值最少进度70
                this.list.orderList[j].top = 70;
                //本阶段加了长度，后面都得加上等长，循环加
                for (var s = j ; s < this.list.orderList.length; s++) {
                  //每个阶段循环增加
                  this.list.orderList[s].top = this.list.orderList[s-1].top + 70;
                }
                //总长度加每个进度之间的补差
                this.list.percentage = this.list.orderList[this.list.orderList.length-1].top;
              }
            }
          }
                },
                function(err) {
                    console.log(err);
                });
      },


    // 跳转到评价页
    selectSpeed(){
    this.$router.push({
        path: "/repairsOne",
        query: {
          repairId: this.$router.history.current.query.repairId,
          repairState:this.repairState, 
          handleMan: this.handleMan,
          handleId:  this.handleId
        }
      });
    },
    },
    

   
  }

    




// WEBPACK FOOTER //
// ./src/components/repairComponents/repairsThr.vue